import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { motion } from 'framer-motion'

const InViewFadeAnimation = ({ children, parent, className }) => {
  const ref = useRef(parent ?? null)

  const transition = {
    duration: 1.1,
    ease: 'easeInOut', //[0.42, 0, 0.58, 1],
  }

  return (
    <motion.div
      ref={ref}
      aria-hidden="true"
      className={className}
      viewport={{ amount: 0.1, once: true }}
      initial={{ y: 34, opacity: 0, transition }}
      whileInView={{
        y: 0,
        x: 0,
        opacity: 1,
        transition,
      }}
    >
      {children}
    </motion.div>
  )
}

const InViewSlideAnimation = ({ children, slide_direction, className }) => {
  let slideInitial = {
    x: 50,
    y: 0,
    opacity: 0,
  }
  switch (slide_direction) {
    case 'right':
      slideInitial.opacity = 0
      slideInitial.x = -50
      break

    case 'up':
      slideInitial.opacity = 0
      slideInitial.y = -50
      slideInitial.x = 0
      break
    case 'down':
      slideInitial.opacity = 0
      slideInitial.y = 50
      slideInitial.x = 0
      break

    default:
      break
  }
  return (
    <motion.div
      className={className}
      whileInView={{
        x: 0,
        opacity: 1,
        transition: {
          type: 'spring',
          bounce: 0.4,
          duration: 3.4,
        },
      }}
      viewport={{
        amount: 0.1,
        once: true,
      }}
      initial={slideInitial}
    >
      {children}
    </motion.div>
  )
}

export const InViewSimpleTransition = ({
  children,
  cancel_animation,
  type,
  className,
  parent,
  slide_direction,
}) => {
  if (cancel_animation) {
    return <div>{children}</div>
  }

  return type === 'fade' ? (
    <InViewFadeAnimation className={className} parent={parent}>
      {children}
    </InViewFadeAnimation>
  ) : (
    <InViewSlideAnimation className={className} slide_direction={slide_direction}>
      {children}
    </InViewSlideAnimation>
  )
}

InViewFadeAnimation.propTypes = {
  children: PropTypes.any,
  parent: PropTypes.any,
  className: PropTypes.string,
}
InViewSlideAnimation.propTypes = {
  children: PropTypes.any,
  animate: PropTypes.bool,
  slide_direction: PropTypes.string,
  className: PropTypes.string,
  parent: PropTypes.any,
}

InViewSimpleTransition.propTypes = {
  children: PropTypes.any,
  cancel_animation: PropTypes.bool,
  type: PropTypes.oneOf(['fade', 'slide']).isRequired,
  parent: PropTypes.any,
  slide_direction: PropTypes.string,
  className: PropTypes.string,
}
